/** @typedef {import('./chatThreadTypes.js').ChatMessage} ChatMessage */

/**
 * @param {ChatMessage[]} messages
 */
export function buildChatExchanges(messages) {
  /** @type {Map<string, { orderKey: number, queryVersions: Map<number, { user?: ChatMessage, assistants: Map<number, ChatMessage> }> }>} */
  const exchanges = new Map()

  for (const m of messages) {
    if (!m) continue
    const exchangeId = m.exchangeId ?? m.id
    const versionIndex = typeof m.versionIndex === 'number' ? m.versionIndex : 0
    const createdAt = typeof m.createdAt === 'number' ? m.createdAt : 0

    if (!exchanges.has(exchangeId)) {
      exchanges.set(exchangeId, { orderKey: createdAt, queryVersions: new Map() })
    }
    const ex = exchanges.get(exchangeId)
    if (!ex) continue

    ex.orderKey = Math.min(ex.orderKey, createdAt)
    if (!ex.queryVersions.has(versionIndex)) ex.queryVersions.set(versionIndex, { assistants: new Map() })
    const qv = ex.queryVersions.get(versionIndex)
    if (!qv) continue

    if (m.role === 'user') qv.user = m
    if (m.role === 'assistant') {
      const aIdx = typeof m.assistantVersionIndex === 'number' ? m.assistantVersionIndex : 0
      qv.assistants.set(aIdx, m)
    }
  }

  return [...exchanges.entries()]
    .map(([exchangeId, data]) => ({ exchangeId, ...data }))
    .sort((a, b) => a.orderKey - b.orderKey)
}
